export const TAB_CONSTANTS = {
  MORE_BUTTON_WIDTH: 40,
  GAP_PX: 4,
  SCROLL_PEEK_OFFSET: 48,
  INITIAL_CALC_DELAY: 250,
} as const;
